import React from "react";

import cx from "classnames";

import "../solid.min.css";
import "../fa-light.min.css";
import "../fontawesome.min.css";

import "./PageNav.css";

const PageNav = props => {
  const { currentPage, maxPageCount, onChange, totalPages } = props;
  let allPages = [];
  let i;

  for (i = 1; i <= totalPages; i++) {
    allPages.push({
      num: i
    });
  }

  const start = Math.max(
    Math.min(currentPage - maxPageCount / 2, totalPages - maxPageCount),
    0
  );

  const end = Math.max(
    Math.max(currentPage + maxPageCount / 2, maxPageCount / 2),
    maxPageCount
  );
  const pagesInView = allPages.slice(start, end);

  const active = pg => (pg === currentPage ? "active" : "");

  const arrowStyles = cx({
    "page-btn": true,
    "d-flex": true,
    "flex-aic": true,
    "flex-jse": true,
    "prev-inactive": currentPage === 1,
    "next-inactive": currentPage === pagesInView.length
  });

  return (
    <div className="d-flex flex-jse">
      <div className="d-flex">
        <button
          className={arrowStyles}
          onClick={() => {
            if (currentPage > 1) {
              onChange(currentPage - 1);
            }
          }}
        >
          <i className="fas fa-caret-left" />
        </button>
        {pagesInView.map(page => {
          return (
            <button
              key={page.num}
              className={`button page-btn d-flex flex-aic ${active(page.num)}`}
              onClick={() => {
                onChange(page.num);
              }}
            >
              <p className="mar-a ta-center w-100">{page.num}</p>
            </button>
          );
        })}
        <button
          className={arrowStyles}
          onClick={() => {
            if (currentPage < totalPages) {
              onChange(currentPage + 1);
            }
          }}
        >
          <i className="fas fa-caret-right" />
        </button>
      </div>
    </div>
  );
};

export default PageNav;



// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/PageNav/PageNav.js